import { User as UserResponse } from '@/DTOS/User/Response/User';
import { debounce } from 'lodash';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/User/UserModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { UserColumn } from './UserColumn';

interface Props {
  handleDocs: (record: UserResponse) => void;
}

const UserTable: FC<Props> = ({ handleDocs }) => {
  const dispatch = useDispatch();

  const reduxUser = useSelector((state: RootState) => state.models?.user);
  const users = useSelector((state: RootState) => state.store?.user?.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxUser.props.skip / reduxUser.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = useCallback((record: any) => {
    window.open(`/administration/user/edit?id=${record?.id}`, '_blank');
  }, []);

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxUser.props.take,
    total: reduxUser.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxUser?.props?.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={users ?? []}
        pagination={paginationConfig}
        columns={UserColumn(handleEdit, handleDocs)}
      />
    </>
  );
};

export default UserTable;
